import { AuditCard } from "@/pages/a7/Audit/AuditCard";
import i18n from "@/i18n";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button, Link } from "@heroui/react";
import { useParams } from "react-router-dom";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

import { A7OPCVMCompositionsEditCard } from "./edit_card";

import { getCompositionsAuditColumns } from "./columns";

const table_name = "a7_opcvm_compositions";

export const A7OPCVMCompositionsEdit = () => {
  const { id } = useParams<{ id: string }>();
  const { t, i18n: i18nClient } = useTranslation(["tables", "common"]);
  const auditColumns = useMemo(
    () => getCompositionsAuditColumns(t),
    [t, i18nClient.language],
  );

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full bg-gray-50">
      <div className="flex flex-col gap-10 p-10">
        <div className="flex">
          <div className="flex-grow flex justify-center">
            <A7OPCVMCompositionsEditCard id={Number(id)} />
          </div>
          <div>
            <Button
              href={toWorkspacePath(
                `/admin/a7_fia_compositions?file_id_equals=${id}`,
              )}
              variant="bordered"
              color="primary"
              showAnchorIcon
              as={Link}
              radius="full"
              className="bg-white border-1 border-neutral-300 shadow-xl"
            >
              {t("a7_opcvm_compositions.title", {
                ns: "tables",
                defaultValue: "Compositions",
              })}
            </Button>
          </div>
        </div>
        <AuditCard
          client={"a7"}
          id={Number(id)}
          name={table_name}
          audit_columns={auditColumns}
        />
      </div>
    </div>
  );
};
